(() => {
  const TABLE_SELECTOR = '.bss-b2b-cart-item-qty-table, .bss-b2b-qty-table-wrapper table';
  const POLL_MS = 400;

  const normalizeNumber = (str) => parseFloat(str.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));

  const parseTiers = (table) => {
    const tiers = [];
    table.querySelectorAll('tr').forEach((row) => {
      const text = row.textContent.replace(/\s+/g, ' ').trim();
      const euroIndex = text.indexOf('€');
      if (euroIndex === -1) return;

      const qtyMatch = text.slice(0, euroIndex).match(/\d+/);
      const priceMatch = text.slice(euroIndex + 1).match(/[\d.,]+/);
      if (!qtyMatch || !priceMatch) return;

      const minQty = parseInt(qtyMatch[0], 10);
      const price = normalizeNumber(priceMatch[0]);
      if (isNaN(minQty) || isNaN(price)) return;

      tiers.push({ minQty, price });
    });

    return tiers.sort((a, b) => a.minQty - b.minQty);
  };

  const formatPrice = (amount) => `€${amount.toFixed(2).replace('.', ',')}`;

  const init = (row) => {
    const priceEl = row.querySelector('.money');
    const oldPriceEl = row.querySelector('[data-tiered-price-old]');
    const quantityInput = document.getElementById('Quantity');
    if (!priceEl || !oldPriceEl || !quantityInput) return;

    const basePriceText = priceEl.textContent;
    let table = null;

    const tick = () => {
      if (!table) {
        table = document.querySelector(TABLE_SELECTOR);
        if (!table) return;
      }

      const tiers = parseTiers(table);
      if (tiers.length < 2) return;

      const qty = parseInt(quantityInput.value, 10) || 1;
      const baseTier = tiers[0];
      let currentTier = baseTier;
      for (const tier of tiers) {
        if (tier.minQty <= qty) currentTier = tier;
      }

      if (currentTier !== baseTier) {
        const newPriceText = formatPrice(currentTier.price);
        if (priceEl.textContent !== newPriceText) priceEl.textContent = newPriceText;
        if (oldPriceEl.hidden) oldPriceEl.hidden = false;
      } else {
        if (priceEl.textContent !== basePriceText) priceEl.textContent = basePriceText;
        if (!oldPriceEl.hidden) oldPriceEl.hidden = true;
      }
    };

    setInterval(tick, POLL_MS);
    quantityInput.addEventListener('input', tick);
    quantityInput.addEventListener('change', tick);

    tick();
  };

  document.querySelectorAll('[data-tiered-price-row]').forEach(init);
})();
